import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
  header: {
    justifyContent: "center",
    padding: 15,
    backgroundColor: "#0a505c",
  },
  title: {
    color: "#fff",
    fontFamily: "RobotoBold",
    fontSize: 30,
  },
  blackTitle: {
    fontFamily: "RobotoBold",
    fontSize: 30,
  },
  merxImageContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: "80px",
    width: "100%",
    height: "200px",
  },
  merxImage: {
    width: "600px",
    height: "150px",
  },
  image: {
    flex: 1,
    justifyContent: "space-around",
    fontFamily: "Poppins",
  },
  imageColor: {
    color: "#fff",
    justifyContent: "center",
    width: 250,
  },
  clients: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    margin: 10,
  },
  consumeTitle: {
    fontFamily: "RobotoBold",
    fontSize: 26,
    textDecoration: "underline",
    marginBottom: 10,
  },
  view: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    fontSize: 15,
  },
  consumeColumn: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#0a505c",
  },
  consumeCard: {
    height: "100%",
    backgroundColor: "#fff",
    border: 1,
    borderColor: "#000",
    borderRadius: 5,
    padding: 15,
    flex: 1,
    margin: 5,
  },
  textBody: {
    padding: 25,
    fontSize: 20,
    textAlign: "left",
  },
  clientBody: {
    textAlign: "center",
    margin: 10,
  },
  destaque: {
    flex: 1,
    height: "100%",
  },
  capa: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  invoice: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  invoiceCard: {
    backgroundColor: "#fff",
    borderRadius: 5,
    padding: 10,
    flex: 1,
    margin: 4,
  },
  invoiceColumn: {
    fontFamily: "RobotoBold",
    fontSize: 12,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  invoiceBody: {
    margin: 5,
    fontSize: 10,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  contactLine: {
    alignItems: "center",
    flexDirection: "row",
    fontSize: 14,
    marginBottom: 10,
  },
  contactLabel: {
    fontFamily: "RobotoBold",
    fontSize: 14,
    marginRight: 5,
  },
  gridColumn: {
    flex: 1,
    textAlign: "center",
  },
  gridRow: {
    flexDirection: "row",
    marginBottom: 10,
    justifyContent: "space-between",
  },
  bar: {
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    backgroundColor: "#0a505c",
    width: 40,
  },
  economy: {
    display: "flex",
    fontFamily: "RobotoBold",
    fontSize: 11,
    width: 80,
    alignItems: "center",
  },
});
